import React, { useState } from "react";
import { TextField, Button, InputAdornment, IconButton } from "@mui/material";
import EyeIcon from "@styles/all-images/icons/eye-icon.svg";
import EyeOffIcon from "@styles/all-images/icons/eye-off-icon.svg";
import { useTranslation } from "react-i18next";

const SetNewPassword = () => {
  const { t } = useTranslation("auth");
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleToggleNewPassword = () => {
    setShowNewPassword(!showNewPassword);
  };

  const handleToggleConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  return (
    <div className="tw-min-h-screen tw-flex">
      {/* Left Section: Background Image */}
      <div className="lg:tw-w-3/4 md:tw-w-2/4 sm:tw-w-full tw-hidden login-bg tw-bg-cover tw-bg-center sm:tw-flex tw-items-end tw-justify-start tw-text-white tw-p-14">
        <div className="tw-px-4">
          <h1 className="tw-font-bold font-size-5xl tw-mb-4 tw-leading-[74px]">
            Innovative Collateral & <br /> Risk Solutions
          </h1>
        </div>
      </div>

      {/* Right Section: Set New Password Form */}
      <div className="lg:tw-w-1/3 md:tw-w-2/4 sm:tw-w-full tw-w-full tw-flex tw-items-center tw-justify-center">
        <div className="tw-w-full tw-max-w-md tw-px-16">
          <div className="tw-mb-8">
            <img
              src="/logo/Logo.svg"
              alt="Logo"
              className="tw-mx-auto tw-max-w-[139px] tw-max-h-[32px]"
            />
          </div>

          <form>
            <h2 className="tw-text-2xl tw-font-semibold tw-mb-6">
              Set New Password
            </h2>
            <p className="tw-text-gray-600 tw-mb-8">
              This password should be different from the previous password.
            </p>

            {/* New Password Input */}
            <div className="form-group tw-mb-6">
              <p className="font-gray-color-dark font-weight-medium font-size-sm leading tw-mb-2">
                New Password
              </p>
              <TextField
                fullWidth
                type={showNewPassword ? "text" : "password"}
                variant="outlined"
                placeholder="••••••••••"
                className="tw-mb-4"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleToggleNewPassword}
                        edge="end"
                        className="tw-p-1 tw-border tw-border-gray-300 tw-rounded-full hover:tw-bg-gray-100"
                      >
                        {showNewPassword ? (
                          <img src={EyeIcon} alt="EyeIcon" />
                        ) : (
                          <img src={EyeOffIcon} alt="EyeOffIcon" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* Confirm Password Input */}
            <div className="form-group tw-mb-8">
              <p className="font-gray-color-dark font-weight-medium font-size-sm leading tw-mb-2">
                Confirm New Password
              </p>
              <TextField
                fullWidth
                type={showConfirmPassword ? "text" : "password"}
                variant="outlined"
                placeholder="••••••••••"
                className="tw-mb-4"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleToggleConfirmPassword}
                        edge="end"
                        className="tw-p-1 tw-border tw-border-gray-300 tw-rounded-full hover:tw-bg-gray-100"
                      >
                        {showConfirmPassword ? (
                          <img src={EyeIcon} alt="EyeIcon" />
                        ) : (
                          <img src={EyeOffIcon} alt="EyeOffIcon" />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </div>

            {/* Save Button */}
            <Button
              fullWidth
              variant="contained"
              className="tw-py-2 primary-custom-button"
            >
              Save
            </Button>

            {/* Back to Login Link */}
            <div className="tw-text-center tw-mt-6">
              <a
                href="/"
                className="tw-text-sm tw-font-medium tw-leading-6 font-gray-color"
              >
                {t("signIn.backToLogin")}
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default SetNewPassword;
